import { apiSlice } from '../api/apiSlice';
import {
  CreateOrderParams,
  CreateOrderResponse,
  GetOrderParams,
  GetOrderResponse,
  GetOrdersParams,
  GetOrdersResponse,
  GetPdfResponse,
} from './orderApiSliceTypes';

const orderApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation<CreateOrderResponse, CreateOrderParams>({
      query: (params) => ({
        url: '/orders',
        method: 'POST',
        body: {
          deviceType: 'web',
          gateway: 'stripe',
          packageId: params.packageId,
          countryId: params.countryId,
          promoCode: params.promoCode,
        },
      }),
    }),

    getOrders: builder.query<GetOrdersResponse, GetOrdersParams>({
      query: (params) => ({
        url: '/orders',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),

    getOrder: builder.query<GetOrderResponse, GetOrderParams>({
      query: (params) => ({
        url: `/orders/${params.id}`,
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),

    getPdf: builder.query<GetPdfResponse, GetOrderParams>({
      query: (params) => ({
        url: `/orders/${params.id}/pdf`,
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useCreateOrderMutation,
  useGetOrderQuery,
  useGetOrdersQuery,
  useLazyGetOrderQuery,
  useLazyGetOrdersQuery,
  useLazyGetPdfQuery,
  useGetPdfQuery,
} = orderApiSlice;
